import React from 'react';

var VisualSpacer = function (_a) {
    var spacing = _a.spacing;
    return React.createElement("div", { style: { width: '100%', height: "".concat(spacing, "px") } });
};

export { VisualSpacer };
//# sourceMappingURL=index.js.map
